<template>
  <screener-box>
    <p class="body-1">
      Please enter your contact information to
      complete this brief health assessment.
    </p>

    <v-text-field
      id="intro_firstname"
      v-model="contact.firstName"
      :rules="[$validators.isValid()]"
      label="First Name"
      color="info"
    />

    <v-text-field
      id="intro_lastname"
      v-model="contact.lastName"
      :rules="[$validators.isValid()]"
      label="Last Name"
      color="info"
    />

    <v-text-field
      id="intro_phone"
      v-model="contact.phone"
      v-mask="'(###) ###-####'"
      :rules="[
        $validators.isValid(),
        $validators.isValidPhone()
      ]"
      label="Phone Number"
      color="info"
    />
  </screener-box>
</template>

<script>
import { contact } from '@/use/screener'

export default {
  setup: () => ({ contact })
}
</script>

<style lang="scss">
.intro-form {
  border: 3px solid gray !important;
}
</style>
